import { SITE_CONFIG } from '../config';

export const PROPERTY_SAVE_EVENT = 'treas-property-save';
export const FAVORITES_KEY = `propertyFavorites_${SITE_CONFIG.SITE_ID}`;
const CONTACT_KEY = `propertySaveContact_${SITE_CONFIG.SITE_ID}`;
export const PENDING_KEY = `propertySavePending_${SITE_CONFIG.SITE_ID}`;
const memory = new Map();
export const readSaveStorage = (key, fallback) => {
  try { return JSON.parse(localStorage.getItem(key) || 'null') ?? memory.get(key) ?? fallback; }
  catch { return memory.get(key) ?? fallback; }
};
export const writeSaveStorage = (key, value) => {
  try { localStorage.setItem(key, JSON.stringify(value)); memory.delete(key); } catch { memory.set(key, value); }
  window.dispatchEvent(new Event(PROPERTY_SAVE_EVENT));
};
export const normalizeContact = (value = {}) => ({
  name: String(value.name || value.fullName || value.username || '').trim(),
  email: String(value.email || '').trim().toLowerCase(),
  phoneNumber: String(value.phoneNumber || value.phone || '').trim()
});
export const isCompleteContact = (value) => {
  const c = normalizeContact(value);
  return !!c.name && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(c.email) && c.phoneNumber.replace(/\D/g, '').length >= 7;
};
export const getConfirmedContact = () => readSaveStorage(CONTACT_KEY, null);
export const rememberConfirmedContact = (values, lead) => {
  const contact = normalizeContact(values);
  if (!lead?.id || !contact.name || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact.email)) return;
  writeSaveStorage(CONTACT_KEY, { ...contact, chatLeadId: lead.id });
};
export const getSaveContact = (user) => {
  const signedIn = normalizeContact(user);
  if (signedIn.email) {
    const known = getConfirmedContact();
    return known?.email === signedIn.email ? normalizeContact({ ...known, ...Object.fromEntries(Object.entries(signedIn).filter(([, value]) => value)) }) : signedIn;
  }
  return normalizeContact(getConfirmedContact() || readSaveStorage('leadInfo', null) || readSaveStorage('chatLead', {}));
};
export const getFavorites = () => {
  const saved = readSaveStorage(FAVORITES_KEY, []);
  return new Set(Array.isArray(saved) ? saved.map(String) : []);
};
export const setFavorite = (key, saved) => {
  const favorites = getFavorites();
  if (saved) favorites.add(String(key)); else favorites.delete(String(key));
  writeSaveStorage(FAVORITES_KEY, [...favorites]);
};

export const missingSaveFields = (value) => {
  const c = normalizeContact(value);
  return [!c.name && 'name', !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(c.email) && 'email', c.phoneNumber.replace(/\D/g, '').length < 7 && 'phone'].filter(Boolean);
};
